import React , { useState , useEffect} from 'react'


import JoditEditor from 'jodit-react';

export default function HtmlEditor( {theId , title , setTheContent , theContent }) {

    const [content,setContent] = useState( "") ;

    function setMyContent( value )
    {
        setContent( value ) ;

        setTheContent( value ) ;
    }

    useEffect(()=>{
        setContent( theContent ) ;
    },[theContent])

    const config = { readonly : false , placeholder : "Start Typings..."}
  return (
    <div>
        <div className="form-group" style={{width: "100%"  }} >
            <label htmlFor={theId}>{title}</label>
            <JoditEditor
                id={theId}
                
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => setMyContent(newContent)} // preferred to use only this option to update the content for performance reasons
                onChange={newContent => {}}
            />
        </div>
    </div>
  )
}
